module.exports = __webpack_public_path__ + "img/img-box-services-support-left.75604c24.png";